import React from "react";
import { useField } from "formik";

function CheckboxMultiSelect({
    label,
    name,
    options = [],
    required = false,
    onChange,
}) {
    const [field, meta, helpers] = useField(name);
    const { setValue } = helpers;

    const valuesArray = field.value || [];

    const handleChange = (checked, item) => {
        const updated = checked
            ? [...valuesArray, item]
            : valuesArray.filter((x) => x.value !== item.value);

        setValue(updated);
        typeof onChange === "function" && onChange(updated);
    };

    return (
        <div style={{ marginBottom: "16px", width: "100%" }}>
            {/* Label */}
            {label && (
                <label
                    className="mb-2 fw-semibold"
                    style={{ fontSize: "12px", color: "#0F2A44" }}
                >
                    {label}
                    {required && <span> *</span>}
                </label>
            )}

            {/* Checkboxes */}
            <div className="d-flex flex-column gap-2">
                {options.map((item) => {
                    const checked = valuesArray.some(
                        (x) => x.value === item.value
                    );

                    return (
                        <div
                            key={item.value}
                            className="d-flex gap-2 align-items-center"
                            style={{ fontSize: "12px" }}
                        >
                            <input
                                id={`checkbox-${item.value}`}
                                type="checkbox"
                                checked={checked}
                                onChange={(e) =>
                                    handleChange(e.target.checked, item)
                                }
                                style={{ height: "20px", width: "20px", cursor: "pointer" }}
                            />

                            <label
                                htmlFor={`checkbox-${item.value}`}
                                style={{ cursor: "pointer", margin: 0 }}
                            >
                                {item.label}
                            </label>
                        </div>
                        // <label
                        //     key={item.value}
                        //     className="d-flex gap-2 align-items-center w-auto"
                        //     style={{ fontSize: "12px", cursor: "pointer" }}
                        // >
                        //     <input
                        //         type="checkbox"
                        //         checked={checked}
                        //         onChange={(e) =>
                        //             handleChange(e.target.checked, item)
                        //         }
                        //         style={{ height: "20px", width: "20px" }}
                        //     />
                        //     {item.label}
                        // </label>
                    );
                })}
            </div>

            {/* Error */}
            {meta.touched && meta.error && (
                <div className="error">
                    {typeof meta.error === "string" ? meta.error : meta.error?.value}
                </div>
            )}
        </div>
    );
}

export default CheckboxMultiSelect;
